// File: /js/shared/bootstrap/initSharedUI.js

import { handleAjaxSubmit }  from '/js/shared/handlers/handleAjaxSubmit.js';
import { handleAjaxClick }   from '/js/shared/handlers/handleAjaxClick.js';
import { handleAjaxChange }  from '/js/shared/handlers/handleAjaxChange.js';
import { handleAjaxOnInput } from '/js/shared/handlers/handleAjaxOnInput.js';
import { handleUiClick }     from '/js/shared/handlers/handleUiClick.js';
import { handleUiChange }    from '/js/shared/handlers/handleUiChange.js';
import { initHeaderAutohide } from '/js/shared/components/headerAutohide.js';
import { initKprimeSliders } from '/js/shared/quiz/kprime-slider.js';
import { initEcgIndicators } from '/js/shared/components/ecgIndicator.js';

// Day/night theme: side-effect import — registers the 'night-toggle' data-ui
// click handler on the domExtensions registry at module load (no new document
// listener; the existing handleUiClick listener dispatches it).
import '/js/shared/components/nightMode.js';

export function initSharedUI() {
  // 1) Intercept any <form data-ajax-submit="true"> for AJAX
  document.addEventListener('submit', handleAjaxSubmit);

  // 2) Handle any click on elements opted into AJAX clicks
  document.addEventListener('click', handleAjaxClick);

  // 3) Handle any change on elements opted into AJAX changes
  document.addEventListener('change', handleAjaxChange);
  
  // 4) Handle any input on elements opted into AJAX changes
  document.addEventListener('input', handleAjaxOnInput);

	// 4bis) Handle input in the forme of paste
	document.addEventListener('paste', (e) => {
  		setTimeout(() => handleAjaxOnInput(e), 0);
	});

  // 5) UI-only handlers (modals, toggles, etc.)
  document.addEventListener('click', handleUiClick);
  document.addEventListener('change', handleUiChange);

  // 6) Auto-hide the sticky header while reading on content/module pages
  //    (mobile only). Self-gates by viewport + body[data-page]; inert
  //    elsewhere. See components/headerAutohide.js.
  initHeaderAutohide();

  // 7) Kprime participant sliders (answer_format='kprime'). Element-scoped,
  //    no-op when no `[data-kprime-slider]` is present. See quiz/kprime-slider.js.
  initKprimeSliders();

  // 8) The ECG selection indicator (the visual signature) on every [data-ecg]
  //    nav/tab strip — menu, Elements tab bars, the vignette read-view tabs.
  //    Element-scoped, no-op when absent. See components/ecgIndicator.js.
  initEcgIndicators();

  // 9) (other shared features: dark mode, toasts…)
}
